export const cookie = {
    // expire time is on minutes
    create: (name, value, expireTime) => {
        expireTime = expireTime ? (expireTime * 60 * 1000) : (1440 * 60 * 1000); // Default 24 hours
        let date = new Date();
        date.setTime(date.getTime() + expireTime);
        let expires = "; expires=" + date.toGMTString();
        document.cookie = name + "=" + value + expires + "; path=/";
    },
    get: (name) => {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");
        if (parts.length == 2) {
            return parts.pop().split(";").shift();
        }
    },
    delete: function(name) {
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
};